<div
  *ngIf="paymentAlreadyTaken; else PaymentFlow"
  class="already-taken-payment"
>
  <p>We have already taken a payment on this offer.</p>
  <dgx-components-button (clicked)="refreshPage()">
    Continue
  </dgx-components-button>
</div>

<ng-template #PaymentFlow>
  <div
    *ngIf="paymentProcessing || (cachingOrder | async)"
    class="processing-payment"
  >
    <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" r="45" />
    </svg>

    <ng-container *ngIf="(cachingOrder | async) === false">
      <h3>Processing payment...</h3>
      <p>This sometimes takes a minute or two.</p>
      <p>
        Please don't refresh the page - this might mean you have to start your
        order again. <br />And you could be charged twice.
      </p>
    </ng-container>
  </div>

  <app-simple-loader
    *ngIf="
      !page && result?.order?.status !== WorldPayOrderStatus.AlreadyProcessed
    "
  >
  </app-simple-loader>

  <div
    id="paymentForm"
    [class.test-iframe]="testVersion"
    *ngIf="result?.order?.status !== WorldPayOrderStatus.AlreadyProcessed"
  ></div>

  <ng-container *ngIf="result?.order?.status === WorldPayOrderStatus.Cancelled">
    <div class="error--block">Your payment has been cancelled</div>
    Click to
    <a class="link" href="https://www.domesticandgeneral.com/"
      >return to homepage</a
    >
  </ng-container>

  <ng-container
    *ngIf="result?.order?.status === WorldPayOrderStatus.AlreadyProcessed"
  >
    <div class="error--block">Your payment has already been processed</div>
    Click to
    <a class="link" href="https://www.domesticandgeneral.com/"
      >return to homepage</a
    >
  </ng-container>
</ng-template>
